import { getCompanyScopedStorageKey } from './companyScope';

export const THEME_CLASSES = [
  'dark',
  'theme-noir-luxe',
  'theme-ivory-atelier',
  'theme-royal-velvet',
  'theme-obsidian',
  'theme-sage-botanica',
  'theme-midnight-azure',
  'theme-ember',
  'theme-celestial',
  'theme-arctic-blanc',
  'theme-cherry-blossom',
];

const ADMIN_THEME_ROUTES = new Set([
  'availability-management', 'bookings-management', 'order-management',
  'my-tasks', 'services-management', 'staff-management',
  'workflow-management', 'settings', 'subscription',
]);

// Theme-only exceptions: do not change cart or company storage scopes.
const GLOBAL_THEME_ROUTES = new Set(['settings', 'subscription', 'reset-password', 'discover']);

export const isAdminThemePath = (pathname = '') => (
  ADMIN_THEME_ROUTES.has(pathname.split('/').filter(Boolean)[0])
);

export const getThemeStorageKey = (pathname = '') => {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return getCompanyScopedStorageKey('theme', GLOBAL_THEME_ROUTES.has(firstSegment) ? '/' : pathname);
};

export const normalizeTheme = (themeName) => (
  THEME_CLASSES.includes(themeName) ? themeName : 'default'
);

export const readSavedTheme = (storageKey) => {
  if (typeof window === 'undefined') return 'default';

  try {
    const saved = window.localStorage.getItem(storageKey);
    if (saved !== null) return normalizeTheme(saved);

    // Preserve the old settings cache when there is no shared admin theme yet.
    if (storageKey === 'clawfe:theme:global') {
      return normalizeTheme(window.localStorage.getItem('clawfe:theme:settings'));
    }

    const cachedCompany = window.localStorage.getItem(storageKey.replace(':theme:', ':company:'));
    return normalizeTheme(cachedCompany ? JSON.parse(cachedCompany).theme : null);
  } catch {
    // Storage may be unavailable; the backend theme can still be applied later.
    return 'default';
  }
};

export const syncThemeToDocument = (themeName) => {
  if (typeof document === 'undefined') return;

  const nextTheme = normalizeTheme(themeName);
  const classes = document.documentElement.classList;
  THEME_CLASSES.forEach((name) => {
    if (name !== nextTheme && classes.contains(name)) classes.remove(name);
  });
  if (nextTheme !== 'default' && !classes.contains(nextTheme)) classes.add(nextTheme);
};

export const persistTheme = (storageKey, themeName) => {
  if (typeof window === 'undefined') return;

  try {
    if (window.localStorage.getItem(storageKey) !== themeName) {
      window.localStorage.setItem(storageKey, themeName);
    }
  } catch {
    // Rendering the selected theme must not depend on storage permissions.
  }
};
